import { reactive as e, readonly as s } from "vue";
class n {
  constructor(t) {
    this.defaultContent = t, this.state = e(Object.assign({}, t));
  }
  state;
  switchContext(t) {
  }
  get() {
    return s(this.state);
  }
  set(t) {
    Object.assign(this.state, t);
  }
  reset() {
    Object.assign(this.state, this.defaultContent);
  }
}
export {
  n as InMemoryReactiveState
};
//# sourceMappingURL=index2.js.map
